import type { U3129AutoCompletCriterias } from '../U3129Service';

/** Champs tri autorisés pour POST /U3129/findProject (BL-0598). */
export const U3129_FIND_PROJECT_SORT_FIELDS = [
  'projetNumber',
  'projetName',
  'customerCode',
  'customerName',
] as const;

export type U3129FindProjectSortField = (typeof U3129_FIND_PROJECT_SORT_FIELDS)[number];

export type U3129FindProjectSortOrder = 'ASC' | 'DESC';

export const U3129_FIND_PROJECT_DEFAULT_SORT_FIELD: U3129FindProjectSortField = 'projetNumber';
export const U3129_FIND_PROJECT_DEFAULT_SORT_ORDER: U3129FindProjectSortOrder = 'ASC';

const FILTER_FIELD_NAMES = ['projetNumber', 'projetName', 'customerCode', 'customerName', 'employeeId'] as const;

export function u3129NormalizeFindProjectSortField(value: unknown): U3129FindProjectSortField {
  const s = String(value ?? '').trim();
  if ((U3129_FIND_PROJECT_SORT_FIELDS as readonly string[]).includes(s)) {
    return s as U3129FindProjectSortField;
  }
  return U3129_FIND_PROJECT_DEFAULT_SORT_FIELD;
}

export function u3129NormalizeFindProjectSortOrder(value: unknown): U3129FindProjectSortOrder {
  const s = String(value ?? '').trim().toUpperCase();
  return s === 'DESC' ? 'DESC' : 'ASC';
}

/** Clic en-tête : même colonne → inverse ; nouvelle colonne → ASC. */
export function u3129NextFindProjectSort(
  currentField: U3129FindProjectSortField,
  currentOrder: U3129FindProjectSortOrder,
  clickedField: U3129FindProjectSortField,
): { field: U3129FindProjectSortField; order: U3129FindProjectSortOrder } {
  if (clickedField === currentField) {
    return { field: currentField, order: currentOrder === 'ASC' ? 'DESC' : 'ASC' };
  }
  return { field: clickedField, order: 'ASC' };
}

export interface U3129BuildFindProjectSearchCriteriasParams {
  panelFields?: Record<string, unknown>;
  sortField?: U3129FindProjectSortField;
  sortOrder?: U3129FindProjectSortOrder;
  pageSize?: number;
  /** Si false, n'envoie pas sortField/sortOrder (API défaut ASC). */
  includeSort?: boolean;
}

export function u3129BuildFindProjectSearchCriterias(
  params: U3129BuildFindProjectSearchCriteriasParams,
): U3129AutoCompletCriterias {
  const { panelFields = {}, includeSort = true } = params;
  const out: U3129AutoCompletCriterias = [];

  for (const name of FILTER_FIELD_NAMES) {
    const raw = panelFields[name];
    if (raw == null) continue;
    const value = String(raw).trim();
    if (value === '') continue;
    out.push({ fieldName: name, value });
  }

  if (params.pageSize != null && params.pageSize > 0) {
    out.push({ fieldName: 'pageSize', value: String(params.pageSize) });
  }

  if (includeSort) {
    const sortField = params.sortField ?? u3129NormalizeFindProjectSortField(panelFields.sortField);
    const sortOrder = params.sortOrder ?? u3129NormalizeFindProjectSortOrder(panelFields.sortOrder);
    out.push({ fieldName: 'sortField', value: sortField });
    out.push({ fieldName: 'sortOrder', value: sortOrder });
  }

  return out;
}
